<template>
  <div class="wechat-binding">
    <div class="wechat-login">
      <span class="iconfont icon-wechat"></span>
      <span class="text">绑定微信账号</span>
      <span class="arrow-right"></span>
    </div>

    <div class="wechat-user">
      <div class="avatar">
        <img src="" alt="" class="avatar-img" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'WechatBinding',
  props: {

  },
  data () {
    return {
      resourceUrl: this.$apiConfig.host
    }
  }
}
</script>

<style lang="scss" scoped>
.wechat-binding {
  display: none;
  @include respond-to(desktop) {
    display: block;
  }
}
.wechat-login {
  font-weight: 500;
  font-size: 1.3rem;
  color: #fff;
  .iconfont {
    display: inline-block;
    margin: -2px 4px 0 0;
    vertical-align: middle;
    font-size: 3.2rem;
  }
  .text {
    border-bottom: 2px solid #fff;
    cursor: pointer;
  }
  .arrow-right {
    display: inline-block;
    width: 0;
    height: 0;
    margin: -4px 0 0 6px;
    border-style: solid;
    border-width: 5px 0 5px 8.7px;
    border-color: transparent transparent transparent #fff;
    vertical-align: middle;
  }
}
.wechat-user {
  text-align: center;
  .avatar {
    display: inline-block;
    width: 64px;
    height: 64px;
    border: 2px solid #fff;
    border-radius: 50%;
    overflow: hidden;
    .avatar-img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/WechatBinding.vue